import React from 'react';
import PropTypes from 'prop-types';

// - MUI Components
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogSelectItem from './DialogSelectItem';
import Slide from '@material-ui/core/Slide';
import Typography from '@material-ui/core/Typography';

// - Components
import AddAttributesDialogItem from './AddAttributesDialogItem';
import AddCategoryDialogItem from './AddCategoryDialogItem';

import withStyles from '@material-ui/core/styles/withStyles';

const styles = theme => ({
  root: {
    minWidth: 600,
    height: 368,
    overflowX: 'hidden',
  },
  dialogContainer: {
    height: 'inherit',
    width: 'inherit',
  },
  titleText: {
    width: '50%',
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
  },
  dialogSelectItem: {
    width: 264,
    height: 247,
    borderRadius: theme.spacing(0.5),
    margin: theme.spacing(1.5),
    boxShadow: theme.shadows[1],
  },
  leftHeader: {
    display: 'flex',
    alignItems: 'center',
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  listItem: {
    height: 40,
    '&:focus': {
      backgroundColor: 'transparent',
    },
    '&:hover': {
      backgroundColor: theme.palette.grey[300],
    },
  },
  buttons: {
    marginRight: '8px 8px',
  },
});

class AddSectionDialog extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    handleClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    availableAttributes: PropTypes.array,
    globalConfig: PropTypes.object.isRequired,
    handleAddAttributes: PropTypes.func.isRequired,
    handleCreateCategory: PropTypes.func,
  };

  state = {
    slideSwitch: true,
    // Set to attribute to get rid of warning when initial state was null
    dialogItem: 'attribute',
  };

  dialogComponents = {
    attribute: AddAttributesDialogItem,
    category: AddCategoryDialogItem,
  };

  handleClose = () => {
    this.props.handleClose();
  };

  handleListItemClick = value => {
    this.props.handleClose(value);
  };

  handleSwitch = title => {
    this.setState(prevState => ({
      dialogItem: title,
      slideSwitch: !prevState.slideSwitch,
    }));
  };

  handleBackClick = () => {
    this.setState({ slideSwitch: true });
  };

  dialogExited = () => {
    this.setState({ slideSwitch: true });
  };

  render() {
    const { classes } = this.props;
    const DialogComponent = this.dialogComponents[this.state.dialogItem];
    return (
      <Dialog
        classes={{ paperWidthSm: classes.root }}
        onClose={this.handleClose}
        open={this.props.open}
        onExited={this.dialogExited}
      >
        <Slide
          direction="right"
          in={this.state.slideSwitch}
          appear={false}
          mountOnEnter
          unmountOnExit
        >
          <div className={classes.dialogContainer}>
            <DialogTitle disableTypography>
              <Typography variant="h5"> What would you like to add? </Typography>
            </DialogTitle>
            <DialogContent className={classes.content}>
              <div className={classes.dialogSelectItem}>
                <DialogSelectItem
                  img="standAlone"
                  title="Attribute"
                  subtitle="Add an attribute to the parent level of your profile layout. This is usually used to add longer form attributes like long text, link collections, or text collections."
                  handleSwitch={() => this.handleSwitch('attribute')}
                />
              </div>
              <div className={classes.dialogSelectItem}>
                <DialogSelectItem
                  img="category"
                  title="Category"
                  subtitle="Create a new section of the profile that will contain multiple attributes within it. You can then add your attributes to the category on the main part of the layout page."
                  handleSwitch={() => this.handleSwitch('category')}
                />
              </div>
            </DialogContent>
          </div>
        </Slide>
        <Slide
          direction="left"
          in={!this.state.slideSwitch}
          appear={false}
          mountOnEnter
          unmountOnExit
        >
          <DialogComponent
            classes={classes}
            handleBackClick={this.handleBackClick}
            handleClose={this.handleClose}
            availableAttributes={this.props.availableAttributes}
            globalConfig={this.props.globalConfig}
            handleAddAttributes={this.props.handleAddAttributes}
            handleCreateCategory={this.props.handleCreateCategory}
          />
        </Slide>
      </Dialog>
    );
  }
}

export default withStyles(styles)(AddSectionDialog);
